
import { defineComponent } from 'vue';
import {Expert, Event, Tutor, EventType} from '@/types';
import SeminarHeader from '@/components/online-seminar/SeminarHeader.vue';
import ProgramSection from '@/components/online-seminar/ProgramSection.vue';
import KeyValueSection from '@/components/online-seminar/KeyValueSection.vue';
import CountrySeminarsSection from '@/components/online-seminar/CountrySeminarsSection.vue';
import FeaturesSection from '@/components/online-seminar/FeaturesSection.vue';
import BenefitsSection from '@/components/online-seminar/BenefitsSection.vue';
import ExpertsSection from '@/components/online-seminar/ExpertsSection.vue';

export default defineComponent({
  name: 'OnlineSeminar',
  components: {
    SeminarHeader,
    ProgramSection,
    KeyValueSection,
    CountrySeminarsSection,
    FeaturesSection,
    BenefitsSection,
    ExpertsSection,
  },
  data() {
    return {
      event: {
        id: 1,
        title: 'Кросс-культурная трансформация – взаимодействие с партнёрами из Китая',
        type: 'seminar' as EventType,
        start_datetime: '2025-10-17T10:00:00+00',
        end_datetime: '',
        external_link: ' https://www.exportcenter.ru/events_exportedu/780874/',
        is_secret: false,
        is_closed: false,
        is_locked: false,
        is_one_c: false,
        is_without_tests: false,
        is_show_material: false,
        is_pay_anket: false,
        is_show_letter: false,
        is_scan_requisites: false,
        is_ow: false,
        is_show_trip: false,
        tutors: [
          {
            fullname: 'Людмила Веселова'
          },
          {
            fullname: 'Константин Барабошкин'
          }
        ] as Tutor[]
      } as Event,
      experts: [
        {
          pic: 'maslov.png',
          title: 'Алексей Маслов',
          text: 'Директор, профессор, доктор исторических наук<br/> Институт Стран Азии и Африк МГУ им. М.В. Ломоносова<br/>' +
              '<ul>' +
              '<li>современное развитие стран Азии </li>' +
              '<li>политическое и социально-экономическое развитие Китая </li>' +
              '<li>национальные традиции</li>' +
              '<li>бизнес и предпринимательство в Азии </li>' +
              '</ul>'
        },
        {
          pic: 'starodubcev.png',
          title: 'Иван Стародубцев',
          text: '' +
              '<ul>' +
              '<li>Независимый эксперт-практик: российско-турецкие отношения, сделки ВЭД, кросс-культурная деловая коммуникация.</li>' +
              '<li>Эксперт Института Ближнего Востока, Российского совета по международным делам.</li>' +
              '<li>Автор книг: «Топливно-энергетический комплекс Турции и энергетический фактор в российско-турецких отношениях», «Трансформирующаяся Турция», «Россия – Турция: 500 лет беспокойного соседства», «Турецкие диалоги-1» и «Турецкие диалоги-2», Учебное пособие ШЭ РЭЦ «Турецкая Республика. Особенности ведения бизнеса» (в печати).</li>' +
              '<li>Ведущий авторских программ на радио и ТВ</li>' +
              '</ul>'
        },
        {
          pic: 'eliseev.png',
          title: 'Вячеслав Елисеев',
          text: 'Генеральный директор ООО КА "ДЖОБ ФОР АРАБИСТС"<br/>' +
              '<ul>' +
              '<li>Организация B2B встреч с крупными компаниями на территории ОАЭ, перевод и локализация информационно-презентационных материалов на арабский язык, подготовка представителей компании к участию в международных выставках.</li>' +
              '<li>2021- 2022: организация деловых миссий в г. Дубай для компаний </li>' +
              '<li>2019: выступление в роли лектора практики в рамках 6th Access meeting Export Workshop «GLOBAL GULF TRADE» по теме «Экспорт в страны Персидского залива: результативный ВЭД и работа над ошибками».</li>' +
              '</ul>'
        },
        {
          pic: 'sadukzade.png',
          title: 'Садыгзаде Мурад Салех Оглы',
          text: 'Президент Российской ближневосточной ассоциации, приглашённый преподаватель Департамента зарубежного регионоведения НИУ ВШЭ, эксперт ливанского аналитического центра «Истишариа».<br/>' +
              '<ul>' +
              '<li>Президент Центра ближневосточных исследований</li>' +
              '<li>Приглашенный преподаватель НИУ ВШЭ, РАНХиГС, МГИМО</li>' +
              '<li>Эксперт Российского совета по международным делам</li>' +
              '<li>Эксперт ливанского форума Истишариа</li>' +
              '<li>Частный консультант по политическим рисками в БВСА</li>' +
              '</ul>'
        },
        {
          pic: 'griva.png',
          title: 'Грива Евгений Владимирович',
          text: 'Заместитель Торгового представителя Российской Федерации в Индии, экс-генеральный директор SIBUR Petrochemical India Pvt. Ltd., кандидат психологических наук, МВА, автор книги «Волшебная Индия, или как жить и управлять людьми в этой стране»<br/>' +
              '<ul>' +
              '<li>Кросс-культурный менеджмент</li>' +
              '<li>Международный бизнес</li>' +
              '<li>Управление персоналом в Южной Азии</li>' +
              '</ul>'
        },
        {
          pic: 'veselova.png',
          title: 'Людмила Веселова',
          text: 'Академический руководитель магистерских программ «Бизнес и политика в современной Азии» и «Международный бизнес в АТР», доцент, кандидат исторических наук НИУ ВШЭ (Санкт-Петербург)<br/>' +
              '<ul>' +
              '<li>7 лет активной работы с китайскими поставщиками и заводами, координация деятельности заводов в КНР.</li>' +
              '<li>Участие в проектах-заказах от РЖД по созданию осветительных приборов для локомотивов.</li>' +
              '<li>Опыт работы с компаниями, специализирующихся на сувенирной продукции, опыт реализации успешных проектов для компаний «Связной», «Сибирское здоровье», «Coca-Cola» и т.д.</li>' +
              '</ul>'
        }
      ] as Expert[]
    };
  },
  mounted() {
    //@ts-ignore
    this.$parent.init();
  }
});
